const API_BASE = process.env.REACT_APP_API_URL;
const API_URL = `${API_BASE}Parametro`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export async function getParametros() {
  const res = await fetch(API_URL, {
    headers: getAuthHeaders()
  });
  const data = await res.json();
  if (Array.isArray(data) && data.length > 0 && data[0].id_detaparametro !== undefined) {
    return data.map(item => ({
      ...item,
      id_parametro: item.id_detaparametro
    }));
  }
  return data;
}

export async function createParametro(values) {
  try {
    await fetch(API_URL, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        nombre: values.nombre,
        descripcion: values.descripcion
      })
    });
    return true;
  } catch {
    return false;
  }
}

export async function editParametro(id, values) {
  try {
    await fetch(`${API_URL}/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        ...values,
        usuarioCreacion: null,
        usuarioEdicion: null,
        fechaCreacion: null,
        fechaEdicion: null
      })
    });
    return true;
  } catch {
    return false;
  }
}

export async function deleteParametro(id) {
  try {
    await fetch(`${API_URL}/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return true;
  } catch {
    return false;
  }
}
